import {
  INSURANCE_SUMMARY_FAIL,
  INSURANCE_SUMMARY_REQUEST,
  INSURANCE_SUMMARY_SUCCESS,
  DETAIL_INSURANCE_REQUEST,
  DETAIL_INSURANCE_SUCCESS,
  DETAIL_INSURANCE_FAIL,
  LIST_INSURANCE_INVOICE_ADDRESS_REQUEST,
  LIST_INSURANCE_INVOICE_ADDRESS_SUCCESS,
  LIST_INSURANCE_INVOICE_ADDRESS_FAIL,
  LIST_INSURANCE_INVOICE_ADDRESS_SUMMARY_REQUEST,
  LIST_INSURANCE_INVOICE_ADDRESS_SUMMARY_SUCCESS,
  LIST_INSURANCE_INVOICE_ADDRESS_SUMMARY_FAIL,
  CREATE_INSURANCE_INVOICE_ADDRESS_REQUEST,
  CREATE_INSURANCE_INVOICE_ADDRESS_SUCCESS,
  CREATE_INSURANCE_INVOICE_ADDRESS_FAIL,
  DETAIL_INSURANCE_INVOICE_ADDRESS_REQUEST,
  DETAIL_INSURANCE_INVOICE_ADDRESS_SUCCESS,
  DETAIL_INSURANCE_INVOICE_ADDRESS_FAIL,
  RESET_DETAIL_INSURANCE_INVOICE_ADDRESS,
  UPDATE_INSURANCE_INVOICE_ADDRESS_REQUEST,
  UPDATE_INSURANCE_INVOICE_ADDRESS_SUCCESS,
  UPDATE_INSURANCE_INVOICE_ADDRESS_FAIL,
  DELETE_INSURANCE_INVOICE_ADDRESS_REQUEST,
  DELETE_INSURANCE_INVOICE_ADDRESS_SUCCESS,
  DELETE_INSURANCE_INVOICE_ADDRESS_FAIL
} from '../../constants/insurance'

const initialState = {
  loading: false,
  insuranceSummary: [],
  loadingDetail: false,
  loadingUpdate: false,
  loadingDelete: false,
  insurance: {},
  error: null,
  pageable: {},
  invoiceAddresses: [],
  invoiceAddressDetail: {},
  loadingInvoiceAddressDetail: false,
  loadingInvoiceAddress: false,
  insuranceInvoiceAddressSummaries: [],
  loadingInvoiceAddressSummary: false
}

const insuranceReducer = (state = initialState, action) => {
  switch (action.type) {
    case INSURANCE_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case INSURANCE_SUMMARY_SUCCESS:
      return { ...state, loading: false, insuranceSummary: action.payload }
    case INSURANCE_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }

    case DETAIL_INSURANCE_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_INSURANCE_SUCCESS:
      return { ...state, loadingDetail: false, insurance: action.payload }
    case DETAIL_INSURANCE_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }

    case LIST_INSURANCE_INVOICE_ADDRESS_REQUEST:
      return { ...state, loadingInvoiceAddress: true }
    case LIST_INSURANCE_INVOICE_ADDRESS_SUCCESS:
      return {
        ...state,
        loadingInvoiceAddress: false,
        invoiceAddresses: action.payload,
        pageable: action.pageable
      }
    case LIST_INSURANCE_INVOICE_ADDRESS_FAIL:
      return {
        ...state,
        loadingInvoiceAddress: false,
        error: action.payload,
        invoiceAddresses: []
      }

    case LIST_INSURANCE_INVOICE_ADDRESS_SUMMARY_REQUEST:
      return { ...state, loadingInvoiceAddressSummary: true }
    case LIST_INSURANCE_INVOICE_ADDRESS_SUMMARY_SUCCESS:
      return {
        ...state,
        loadingInvoiceAddressSummary: false,
        insuranceInvoiceAddressSummaries: action.payload
      }
    case LIST_INSURANCE_INVOICE_ADDRESS_SUMMARY_FAIL:
      return {
        ...state,
        loadingInvoiceAddressSummary: false,
        error: action.payload,
        insuranceInvoiceAddressSummaries: []
      }

    case CREATE_INSURANCE_INVOICE_ADDRESS_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_INSURANCE_INVOICE_ADDRESS_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_INSURANCE_INVOICE_ADDRESS_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }

    case DETAIL_INSURANCE_INVOICE_ADDRESS_REQUEST:
      return { ...state, loadingInvoiceAddressDetail: true }
    case DETAIL_INSURANCE_INVOICE_ADDRESS_SUCCESS:
      return { ...state, loadingInvoiceAddressDetail: false, invoiceAddressDetail: action.payload }
    case DETAIL_INSURANCE_INVOICE_ADDRESS_FAIL:
      return { ...state, loadingInvoiceAddressDetail: false, error: action.payload }

    case RESET_DETAIL_INSURANCE_INVOICE_ADDRESS:
      return { ...state, invoiceAddressDetail: {}, loadingInvoiceAddressDetail: false }

    case UPDATE_INSURANCE_INVOICE_ADDRESS_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_INSURANCE_INVOICE_ADDRESS_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_INSURANCE_INVOICE_ADDRESS_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }

    case DELETE_INSURANCE_INVOICE_ADDRESS_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_INSURANCE_INVOICE_ADDRESS_SUCCESS:
      return { ...state, loadingDelete: false }
    case DELETE_INSURANCE_INVOICE_ADDRESS_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }

    default:
      return state
  }
}

export default insuranceReducer

